<template>
    <div class="clearfix subtable-font-style pagination-comp">
        <div class="row pagination-wrapper justify-content-between" v-if="nTotalRowCount > 0">
            <div class="d-flex">
                <div class="currentPage">
                    <div class="currentPageContent">
                        <span v-if="nItemsPerPage > nTotalRowCount || ((nCurrentPage - 1) * nItemsPerPage + nItemsPerPage) > nTotalRowCount">
                            {{$n((nCurrentPage - 1) * nItemsPerPage + 1)}}-{{$n(nTotalRowCount)}} {{$t('components.pagination.of')}} {{$n(nTotalRowCount)}}
                        </span>
                        <span v-else>
                            {{$n((nCurrentPage - 1) * nItemsPerPage + 1)}}-{{$n((nCurrentPage - 1) * nItemsPerPage + nItemsPerPage)}} {{$t('components.pagination.of')}} {{$n(nTotalRowCount)}}
                        </span>
                    </div>
                </div>
                <div class="perPage">
                    <form class="perPageContent">
                        <span class="perPageContent__text">{{$t('components.pagination.rows')}}</span>
                        <select v-model="nItemsPerPage" class="form-control form-control-sm subtable-font-style perPageContent__input" @change="fnPageSizeChange($event)">
                            <option v-for="option in arrItemsPerPageOptions" :value="option">
                                {{ option }}
                            </option>
                        </select>
                    </form>
                </div>
            </div>
            <div class="mb-0">
                <nav>
                    <ul class="pagination mb-0">
                        <li :class="[{'disabled': prevPageDisabled}, 'page-item']" v-if="showFirstLastBtns">
                            <a class="page-link" href="#" @click.prevent="startPage()"><span class="mdi mdi-arrow-collapse-left"></span></a>
                        </li>
                        <li :class="[{'disabled': prevPageDisabled}, 'page-item']">
                            <a class="page-link" href="#" @click.prevent="prevPage()"><span class="mdi mdi-arrow-left"></span></a>
                        </li>
                        <li class="page-item" v-for="n in range">
                            <a :class="[{ 'selectedPage': n === nCurrentPage }, 'page-link']" href="#" @click.prevent="setPage(n)">{{$n(n)}}</a>
                        </li>
                        <li :class="[{'disabled': nextPageDisabled}, 'page-item']">
                            <a class="page-link" href="#" @click.prevent="nextPage()"><span class="mdi mdi-arrow-right"></span></a>
                        </li>
                        <li :class="[{'disabled': nextPageDisabled}, 'page-item']" v-if="showFirstLastBtns">
                            <a class="page-link" href="#" @click.prevent="lastPage()"><span class="mdi mdi-arrow-collapse-right"></span></a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

    </div>
</template>
<script>
    /**
     *
     * CONTROL DE PAGINADO
     * Ejemplo:
     *
       <pagination-component :totalRowCount="totalRowCount"
                                      :itemsPerPage="10"
                                      :rangeSize="3"
                                      :showFirstLastBtns="true"
                                      :currentPage="pagePagination"
                                      @evt-pagination-change-page="pagePagination = $event" 
                                      @evt-pagination-change-page-size="fnChangeRowsPerPage($event)"/>
     *
     */
    export default {
        name: "pagination-component",
        data() {
            return {
                nTotalRowCount: this.totalRowCount,
                nItemsPerPage: this.itemsPerPage,
                arrItemsPerPageOptions: this.itemsPerPageOptions,
                nRangeSize: this.rangeSize,
                nCurrentPage: this.currentPage,
            }
        },
        props: {
            totalRowCount: { type: Number, default: 0 },
            itemsPerPage: { type: Number, default: 10 },
            itemsPerPageOptions: { type: Array, default: function () { return [5, 10, 25, 50, 100, 200]; } },
            rangeSize: { type: Number, default: 5 },
            currentPage: { type: Number, default: 1 },
            showFirstLastBtns: { type: Boolean, default: true },
        },
        watch: {
            /**
             * Watcher para cambiar responder cuando se cambien el número de filas
             * @param newVal
             * @param oldVal
             */
            totalRowCount: function (newVal, oldVal) {
                this.nTotalRowCount = newVal;
            },
            /**
             * Watcher para responder cuando se cambia desde fuera la página.
             * Cuando se quiera volver a la 1 se debe cambiar la propiedad
             * @param newVal
             * @param oldVal
             */
            currentPage: function (newVal, oldVal) {
                this.nCurrentPage = newVal;
            },

            itemsPerPage: function (newVal) {
                this.nItemsPerPage = newVal;
            },
        },
        computed: {
            /**
             * Función para calcular el número de paginas.
             * */
            pageCount: function () {
                return Math.ceil(this.nTotalRowCount / this.nItemsPerPage);
            },
            /**
             * Función para calcular el rango a mostrar en los botones de número.
             * */
            range: function () {

                var rangeSize = 5;
                var ret = [];
                var start;

                /* Si especificamos nuevo tamaño */
                if (this.rangeSize > 0) {
                    rangeSize = this.nRangeSize;
                };

                /* Cálculo de las páginas a mostrar */
                start = this.nCurrentPage;
                if (start > this.pageCount - rangeSize && this.pageCount - rangeSize > 0) {
                    start = this.pageCount - rangeSize + 1;
                };
                if (this.pageCount < rangeSize) {
                    rangeSize = this.pageCount;
                    start = 1;
                };
                for (var i = start; i < start + rangeSize; i++) {
                    ret.push(i);
                };
                return ret;
            },
            /**
             * Función para deshabilitar botones cuando se llega a la página 1
             * */
            prevPageDisabled: function () {
                return this.nCurrentPage === 1 ? true : false;
            },
            /**
             * Función para deshabilitar cuando se llega a la última página.
             * */
            nextPageDisabled: function () {
                return this.nCurrentPage === this.pageCount ? true : false;
            },
        },
        methods: {
            /**
             * Ir a la siguiente página.
             * */
            nextPage: function () {
                if (this.nCurrentPage < this.pageCount) {
                    this.nCurrentPage++;
                    this.fnEmitEventPage(this.nCurrentPage);
                }
            },
            /**
             * Ir a la página anterior
             * */
            prevPage: function () {
                if (this.nCurrentPage > 1) {
                    this.nCurrentPage--;
                    this.fnEmitEventPage(this.nCurrentPage);
                }
            },
            /**
             * Ir a la primera página
             * */
            startPage: function () {
                this.nCurrentPage = 1;
                this.fnEmitEventPage(this.nCurrentPage);
            },
            /**
             * Ir a la última página.
             * */
            lastPage: function () {
                this.nCurrentPage = this.pageCount;
                this.fnEmitEventPage(this.nCurrentPage);
            },
            /**
             * Ir a la página indicada por parámetro.
             * @param n
             */
            setPage: function (n) {
                if (n > 0 && n <= this.pageCount) {
                    this.nCurrentPage = n;
                    this.fnEmitEventPage(this.nCurrentPage);
                }
            },
            /**
             * Emite un evento de cambio de página cuando esta cambia para avisar al padre por ejemplo para que se recargue esa página.
             * @param page
             */
            fnEmitEventPage(page) {
                this.$emit('evt-pagination-change-page', page);
            },
            /**
             * Gestión del cambio en la combo de pagesize
             * @param evt
             */
            fnPageSizeChange(evt) {

                    this.setPage(1);
             
                this.$emit('evt-pagination-change-page-size', this.nItemsPerPage);
            },
        }
    }
</script>
<style scoped>
    .pagination-wrapper {
        margin: 0px;
    }

    .pagination-comp {
            padding: 0px 15px;
    }

    .selectedPage {
        font-weight: bold;
    }

    .currentPage {
        margin: 0px 20px 0px 20px;
        display: flex;
        align-items: center;
    }

    .currentPageContent {
        font-weight: 400;
        font-family: 'Source Sans Pro';
        font-size: 12px;
        line-height: 16px;
        color: var(--Int-700)
    }

    .perPage {
        display: flex;
    }

    .perPageContent {
        display: flex;
        align-items: center;
    }

    .perPageContent__text {
        font-weight: 400;
        font-family: 'Source Sans Pro';
        font-size: 12px;
        line-height: 16px;
        color: var(--Int-200);
        margin-left: 15px;
    }

    .perPageContent__input {
        border: none;
        font-weight: 400;
        font-family: 'Source Sans Pro';
        /* font-size: 12px; */
        line-height: 16px;
        color: var(--Int-700)
    }

    .pagination {
        font-weight: 400;
        font-family: 'Source Sans Pro';
        font-size: 12px;
        line-height: 16px;
        color: var(--Int-700)
    }

    .pagination .page-item.disabled .page-link {
        color: var(--Int-50);
        /* pointer-events: none; */
        cursor: not-allowed;
        background-color: transparent;
        border: none !important;
    }

    .pagination .page-item .page-link {
        color: var(--Int-100);
        cursor: pointer;
        background-color: transparent;
        border: none !important;
    }

    .pagination .page-item .page-link:hover {
        color: var(--Int-200);
    }

    .pagination .page-link.selectedPage {
        color: var(--Int-400)
    }
</style>